<template>
  <div>
    <h3>{{ selectedPackage.name }}</h3>
    <abstractTable 
      :columns="usagesColumns" 
      :data="computedUsages"
      :classes="'ui very compact center aligned celled table'"
    />
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default
  },
  props: {
    selectedPackage: { type: Object, required: true},
    usages: { type: Array, required: true }
  },
  computed: {
    usagesColumns () {
      return [
        { header: 'Service', fieldName: 'service', show: true },
        { header: 'Pulses', fieldName: 'quantity', show: true },
        { header: 'Power 1', fieldName: 'power1', show: true },
        { header: 'Power 2', fieldName: 'power2', show: true },
        { header: 'Skin type', fieldName: 'skinType', show: true },
        { header: 'Cooling', fieldName: 'cooling', show: true },
        { header: 'Note', fieldName: 'note', show: true }
      ]
    },
    computedUsages () {
      return this.usages.map(usage => ({
        ...usage,
        service: this.VisitServices[usage.service_id]
      }))
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/visits/visit_components/MedicalMachinePackageUsages.vue